export const pastPageStartYear = 2021

export const contentList = [
  { path: 'chart', text: '天気図' },
  { path: 'satellite', text: '気象衛星' }
]

export const contentsNames = {
  chart: '天気図',
  satellite: '衛星画像'
}
